export default __webpack_public_path__ + "static/media/eight.9c17364d.svg";